import { useAuth0 } from '@auth0/auth0-react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LogoAndName from '../commonUI/LogoAndName';
import { flexCenter } from '../commonUI/cssClasses';
import LoginButton from './LoginButton';

const LoginForm: React.FC = () => {
  const { error } = useAuth0();

  const header = (
    <Box sx={{ width: 'clamp(160px, 17%, 250px)', m: '1.8rem' }}>
      <LogoAndName />
    </Box>
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'grid',
        gridTemplateRows: 'min-content 1fr min-content',
        gridTemplateColumns: '1fr',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        {header}
      </Box>
      <Box sx={{ ...flexCenter, flexDirection: 'column' }}>
        <Typography variant='h1' sx={{ m: '1.5rem' }}>
          Welcome!
        </Typography>
        <LoginButton />
        {error && (
          <Typography
            variant='body1'
            sx={{ m: '1.5rem', color: (theme) => theme.colors.status.red.main }}
          >
            {error.message}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          opacity: 0, // hidden footer, copy header so size is equal
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        {header}
      </Box>
    </Box>
  );
};

export default LoginForm;
